// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import { IconUiInformationCircle } from 'moods-react/Icons';
import { Tooltip, tooltipCaretDirections, tooltipPosition } from 'moods-react/Tooltip';
import { Pill, pillSizes, pillColours } from 'moods-react/Pill';
import approvalsMessages from '../../data/approvals';
import { APPROVAL_STATUS } from '../../api/types/Approvals';
import NoApprovals from './no-approvals/NoApprovalsComponent';
import UnauthorizedComponent from '../unauthorized/UnauthorizedComponent';

import './ApprovalsPage.scss';

type Props = {
  location: {
    pathname: string,
  },
  children?: React.Node,
  approvals: Object,
  actions: {
    getApprovals: Function,
  },
};

class ApprovalsPageComponent extends React.Component<Props> {
  static contextTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }),
  };

  componentDidMount() {
    if (this.props.approvals.items.length === 0) {
      this.props.actions.getApprovals({ status: APPROVAL_STATUS.pending, fromItem: 0 });
    }
  }

  getContactDetails() {
    return this.props.config.contacts.toPopulateProductPage;
  }

  getContent() {
    const { approvals, children } = this.props;

    if (approvals.isUnauthorized) {
      return <UnauthorizedComponent contactDetails={this.getContactDetails()} />;
    }

    if (!approvals.isLoading && approvals.total === 0) {
      return <NoApprovals />;
    }

    return children;
  }

  render() {
    const { approvals } = this.props;

    return (
      <div className="approvals-page-component">
        {!approvals.isUnauthorized && (
          <div className="approvals-page-component__header">
            <h2 className="u-fontSize-xl approvals-page-component__title">
              {this.context.intl.formatMessage(approvalsMessages.approvalsNavItem_awaiting)}
              {approvals.pendingCount ? (
                <span className="approvals-page-component__pill">
                  <Pill className="u-marginLeft-xxs" size={pillSizes.SMALL} colour={pillColours.BLUEBERGINE}>
                    {approvals.pendingCount}
                  </Pill>
                </span>
              ) : null}
              <span className="fade-in-children__parent">
                <IconUiInformationCircle className="-small u-color-light u-marginLeft-xxs" />
                <span className="approvals-page-component__tooltip u-position-relative fade-in-children__child">
                  <Tooltip
                    panel
                    heading={this.context.intl.formatMessage(approvalsMessages.approvalsNavItem_awaiting_tooltipHeader)}
                    caretDirection={tooltipCaretDirections.LEFT_TOP}
                    position={tooltipPosition.RIGHT_BELOW}
                  >
                    {this.context.intl.formatMessage(approvalsMessages.approvalsNavItem_awaiting_tooltipText)}
                  </Tooltip>
                </span>
              </span>
            </h2>
          </div>
        )}
        {this.getContent()}
      </div>
    );
  }
}

export default ApprovalsPageComponent;
